var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiHeader',{attrs:{"menu-items":_vm.mainMenu,"i18n":_vm.mainMenuTranslations,"languages":_vm.languages,"search-documents":_vm.searchDocuments,"logo-url":_vm.mainPageUrl},on:{"get-search":_vm.fetchSearchData}})}
var staticRenderFns = []

export { render, staticRenderFns }